import type { GlobalSearchResultItem } from 'models';
import { Loading } from 'ui';
import { NoResultsItem } from '../../search-items';
import { convertAssetableType, getSearchResultPath } from '../../search-result-routes';
import { RecentSearchItem } from './recent-search-item';

type P = {
  clearSearch: () => void;
  isLoading: boolean;
  onNavigate: (path: string) => void;
  recentSearches: GlobalSearchResultItem[];
};

const RecentSearchesPanel = ({ clearSearch, isLoading, onNavigate, recentSearches }: P) => {
  const handleItemClick = (item: GlobalSearchResultItem) => {
    clearSearch();
    onNavigate(getSearchResultPath(convertAssetableType(item.type ?? ''), item));
  };

  if (isLoading) {
    return (
      <div className="global-search-input__panel">
        <Loading size="small" />
      </div>
    );
  }

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions -- guards against Select's blur-before-click race, not an interactive element itself
    <div
      className="global-search-input__panel"
      onMouseDown={(event) => {
        event.preventDefault();
      }}
    >
      {recentSearches.length > 0 ? (
        recentSearches.map((item) => (
          <RecentSearchItem
            key={item.id}
            onClick={() => {
              handleItemClick(item);
            }}
            title={item.name ?? ''}
          />
        ))
      ) : (
        <NoResultsItem />
      )}
    </div>
  );
};

export default RecentSearchesPanel;
